angular.module('admin.groups.index', [
  'security.authorization',
  'services.utility',
  'services.adminResource',
  'resources.AdminGroup',
  'services.search'
]);

angular.module('admin.groups.index').config(["$stateProvider", function($stateProvider){
  var main = {
    template: require('./groups.tpl.html'),
    controller: 'AccountGroupsIndexCtrl'
  };

  $stateProvider
    .state('admin.groups', {
      url: '/groups',
      title: 'Manage Account Groups',
      views: {
        'main@': main
      }
   });
}]);

angular.module('admin.groups.index').controller('AccountGroupsIndexCtrl',
  ["$scope", "$route", "$location", "$log", "utility", "adminResource", "searchService", "AdminGroup", function($scope, $route, $location, $log, utility, adminResource, searchService, AdminGroup){

    searchService.setSearchFn(AdminGroup.search);

    searchService.setRedirectBase('/admin/groups/edit');

    var fetchData = function () {
      adminResource.findAccountGroups($scope.query).then(function(data) {
        deserializeData(data);
        //update url in browser addr bar
        $location.search($scope.query);
      }, function(e) {
        $log.error(e);
      });
    };

    var deserializeData = function(data){
      $scope.page = data.meta.page;
      $scope.query = data.meta.query;
      $scope.groups = data.data;
    };

    $scope.$watchCollection('query', function(newState, oldState) {
      if ( angular.equals(newState, oldState) ) {
        return;
      }

      fetchData();
    });

    //select elements and their associating options
    $scope.sorts = [
      {label: "id \u25B2", value: "_id"},
      {label: "id \u25BC", value: "-_id"},
      {label: "name \u25B2", value: "name"},
      {label: "name \u25BC", value: "-name"}
    ];
    $scope.limits = [
      {label: "10 Materiałów", value: 10},
      {label: "20 Materiałów", value: 20},
      {label: "50 Materiałów", value: 50},
      {label: "100 Materiałów", value: 100}
    ];

    $scope.query = $location.search();
    $scope.query.limit = $scope.query.limi || 10;
    fetchData();
  }]);



// WEBPACK FOOTER //
// ./client/src/app/admin/groups/groups.js